import AvailablesModel from '../models/AvailablesModel';

export default class AvailablesCollection extends Backbone.Collection {
  constructor(options) {
    super(options);

    this.model = AvailablesModel;
  }

  url() {
    return (
      appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
      + appConstants.ApiPaths.API_VERSION_PATH
      + appConstants.EndPoints.AVAILABLES_PATH
    );
  }

  parse(data) {
    return data.availabilities ? data.availabilities : data;
  }

  dispatchCallback(payload) {
    const { actionType } = payload;
    const { ActionTypes } = appConstants;

    switch (actionType) {
      case ActionTypes.GET_AVAILABLES:
        Utils.setMakeshiftTokenHeader();
        AvailabilitiesStore.fetch({
          url:
            appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
            + appConstants.ApiPaths.API_VERSION_5_PATH
            + appConstants.EndPoints.AVAILABILITIES_PATH,
          type: 'GET',
          data: payload.postData,
          success: AvailabilitiesStore.onAvailablesHandler,
          error: AvailabilitiesStore.onAvailablesError,
        });
        break;
      case ActionTypes.DELETE_AVAILABLE: {
        Utils.setMakeshiftTokenHeader();
        const shift_id = payload.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')];
        const availableShiftStore = AvailabilitiesStore.getModelById(shift_id);
        const deleteURL = `${appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
        + appConstants.ApiPaths.API_VERSION_5_PATH
        + appConstants.EndPoints.AVAILABILITIES_PATH}/${
          payload.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')]
          }`;

        availableShiftStore.destroy({
          url: deleteURL,
          success: AvailabilitiesStore.onAvailabilityDeleted,
          error: AvailabilitiesStore.onAvailabilityDeletedError,
        });
        break;
      }
      case ActionTypes.DELETE_RECURING_AVAILABLE: {
        Utils.setMakeshiftTokenHeader();
        const shiftId = payload.postData[Utils.getEndpointParam('SHIFT_ID_PARAM')];
        const recurringAvailId = payload.postData[Utils.getEndpointParam('RECURRING_AVAILABILITY_ID')];
        const availableShiftStore = AvailabilitiesStore.getModelById(shiftId);
        const deleteURL = `${appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
        + appConstants.ApiPaths.API_VERSION_PATH
        + appConstants.EndPoints.RECURING_AVAILABILITY}/${
          payload.postData[Utils.getEndpointParam('RECURRING_AVAILABILITY_ID')]
        }/toggle_exception`;
        // let's try and do some of backbones work ourselves
        // instead of using the 'model.destroy' method (which only sends DELETE requests) use POST
        $.ajax({
          url: deleteURL,
          method: 'POST',
          data: {
            except: shiftId,
            id: recurringAvailId,
            'recurring_availability': {
              except: shiftId
            }
          },
          success(response) {
            // note.. we mimic these callbacks.. (here's the callbacks copied from ActionTypes.DELETE_AVAILABLE)..
            //   success: AvailabilitiesStore.onAvailabilityDeleted,
            //   error: AvailabilitiesStore.onAvailabilityDeletedError,
            availableShiftStore.trigger('destroy', availableShiftStore);
            AvailabilitiesStore.trigger('availability:delete:success', availableShiftStore, response);
          },
          error(response) {
            AvailabilitiesStore.trigger('availability:delete:error', response);
          }
        });
        break;
      }
      case ActionTypes.CREATE_AVAILABLE:
        Utils.setMakeshiftTokenHeader();
        const shift = payload.postData;
        const shiftURL = appConstants.ApiPaths.MAKESHIFT_BASE_URL_DEV
          + appConstants.ApiPaths.API_VERSION_5_PATH
          + appConstants.EndPoints.AVAILABILITIES_PATH;
        const availModel = new AvailablesModel(payload.postData);
        const allAvailables = AvailabilitiesStore.getAllAvailables();

        var exists = AvailabilitiesStore.where({
          starts_at: payload.postData[Utils.getEndpointParam('STARTS_AT_PARAM')],
          ends_at: payload.postData[Utils.getEndpointParam('ENDS_AT_PARAM')],
        });
        if (exists && exists.length == 0) {
          AvailabilitiesStore.create(availModel, {
            patch: false,
            url: shiftURL,
            success: AvailabilitiesStore.onAvailabilityCreated,
            error: AvailabilitiesStore.onAvailabilityCreatedError,
          });
        }
        break;
      default:
        break;
    }
  }
}
